import React, { createContext, useReducer } from 'react'

export const SET_VISUAL_AID_DATA = 'SET_VISUAL_AID_DATA'
export const UPDATE_CHANGE_VISUAL_AID_DATA = 'UPDATE_CHANGE_VISUAL_AID_DATA'
export const SET_SELECTED_VISUAL_AID_DATA = 'SET_SELECTED_VISUAL_AID_DATA'
export const SHOW_HIDE_VISUAL_AID_FORM = 'SHOW_HIDE_VISUAL_AID_FORM'

const Reducer = (data, payload) => {
  switch (payload.type) {
    case SET_VISUAL_AID_DATA: {
      return { ...data, data: payload.data }
    }
    case UPDATE_CHANGE_VISUAL_AID_DATA: {
      let tempData = [...data.data.results]
      tempData[payload.data.index] = payload.data
      return { ...data, results: tempData }
    }
    case SET_SELECTED_VISUAL_AID_DATA: {
      return {
        ...data,
        selectedObject: payload.data,
        showVisualAidFormPopup: true,
      }
    }
    case SHOW_HIDE_VISUAL_AID_FORM: {
      return {
        ...data,
        showVisualAidFormPopup: payload.data,
        selectedObject: {},
      }
    }
    default: {
      return {}
    }
  }
}

const initialState = {
  data: {},
  selectedObject: {},
  showVisualAidFormPopup: false,
}

const VisualAidtore = ({ children }) => {
  const [state, dispatch] = useReducer(Reducer, initialState)

  return (
    <VisualAidContext.Provider value={[state, dispatch]}>
      {children}
    </VisualAidContext.Provider>
  )
}

export const VisualAidContext = createContext(initialState)
export default VisualAidtore
